import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Helmet } from "react-helmet";
import { localeEs } from "../../locale/ag-grid-es";
import BreadCrum from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";
import {Button, Col, Input, FormText } from 'reactstrap';
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

const AppImportTutela = ({ token }) => {
    const [data, setData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const gridApi = useRef(null);
    const [loading, setLoading] = useState(true);
    const etiquetas = [
        "Inicio Lossman",
        "Importar Archivos",
        "Facturación Tutela",
    ];

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        {
            field: "Numero_Autorizacion",
            headerName: "Numero Caso",
            flex: 1,
        },
        {
            field: "Numero_Identificacion",
            headerName: "Numero Identificación usuario",
            flex: 1,
        },
        {
            field: "Fecha_Facturacion",
            headerName: "Fecha Facturación",
            flex: 1,
        },
        {
            field: "Numero_Factura",
            headerName: "Numero De Factura ",
            flex: 1,
        },
        {
            field: "Numero_Mipres",
            headerName: "Numero MIPRES ",
            flex: 1,
        },
    ];

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleFileUpload = (e) => {
        
        const file = e.target.files[0];
        if (!file) return;
        
        // Solo guardamos la referencia al archivo, no lo procesamos aún
        setSelectedFile(file);
        // Limpiamos los datos existentes
        setData([]);
    };

    const handleImport = () => {
        setLoading(true); 
        if (!selectedFile) {
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Por favor seleccione un archivo valido",
                showCloseButton: true,
            });
        }
    
        const reader = new FileReader();
        if (selectedFile) {
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array', cellDates: true });
                
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                
                if (jsonData.length < 3) {
                    throw new Error('El archivo no contiene suficientes filas de datos');
                }
                
                const extractedData = [];
                for (let i = 2; i < jsonData.length; i++) {
                    const row = jsonData[i];
                    
                    if (row.length < 6) {
                        continue;
                    }

                    const formatDate = (date) => {
                        if (date instanceof Date) {
                        return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
                        }
                        if (typeof date === 'number' && date > 0) {
                        // Convertir número de Excel a fecha
                        const jsDate = new Date((date - 25569) * 86400 * 1000);
                        return jsDate.toISOString().split('T')[0];
                        }
                        return date || '';
                    };
                    
                    extractedData.push({
                        "Numero_Autorizacion": row[6] || '',
                        "Numero_Identificacion": row[13] || '',
                        "Fecha_Facturacion": formatDate(row[3]),
                        "Numero_Factura": row[7] || '',
                        "Numero_Mipres": row[46] || '',
                    });
                }
                
                if (extractedData.length === 0) {
                    throw new Error('No se encontraron datos válidos en las columnas donde deberia venir la información');
                }
                
                setData(extractedData);

                setLoading(false);

            } catch (err) {
                alert(`Error al procesar el archivo: ${err.message}`);
                setData([]);
                setLoading(false);
            }
        };
    }
        reader.onerror = () => {
            alert('Error al leer el archivo');
            setData([]);
            setLoading(false);
        };
        
        if(selectedFile){
        reader.readAsArrayBuffer(selectedFile);}
    };

    const handleCreateSubmit = (event) => {
        event.preventDefault();
    
        // Enviar los datos de ls IPs
        if(token){
            axios.post("/excel/import/tutela", {
                InfoFacturacion: data,
              }, {
                headers: { Authorization: `Bearer ${token}` }
              })
              .then((response) => {
                if (response.data.success) {
                  // Caso exitoso (sin errores)
                  Swal.fire({
                    icon: "success",
                    title: "¡Creado!",
                    text: "Se ha registrado la información de facturación con éxito",
                    showCloseButton: true,
                  }).then(() => {
                    window.location.reload();
                  });
                } else {
                  // Caso con errores - Mostrar alerta con opción para descargar
                  Swal.fire({
                    icon: "warning",
                    title: "Proceso completado con errores",
                    html: `
                      <div style="text-align: left;">
                        <p><strong>Registros exitosos:</strong> ${response.data.registros_exitosos}</p>
                        <p><strong>Errores encontrados:</strong> ${response.data.errores}</p>
                      </div>
                    `,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Descargar log de errores',
                    cancelButtonText: 'Cerrar',
                    focusConfirm: false,
                    preConfirm: () => {
                      // Esta función se ejecuta al hacer clic en "Descargar log de errores"
                      return new Promise((resolve) => {
                        // Crear el Blob con el contenido del log
                        const blob = new Blob([response.data.log_content], { type: 'text/plain;charset=utf-8' });
                        const url = URL.createObjectURL(blob);
                        
                        // Crear elemento <a> invisible para forzar la descarga
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = response.data.log_filename || 'errores_facturacion.txt';
                        
                        // Añadir al DOM y hacer click
                        document.body.appendChild(a);
                        a.click();
                        
                        // Limpiar
                        setTimeout(() => {
                          document.body.removeChild(a);
                          URL.revokeObjectURL(url);
                          resolve();
                        }, 100);

                        window.location.reload();
                      });
                    }
                  }).then((result) => {
                    if (result.dismiss === Swal.DismissReason.close) {
                      // Opcional: Recargar al cerrar el diálogo
                      window.location.reload();
                    }
                  });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: "Ha ocurrido un error al cargar la información de facturación.",
                  showCloseButton: true,
                });
              });
              
            }
      };

    

    return (
        <>
            <Helmet>
                <title>Importar información de facturación Tutela</title>
            </Helmet>
            <div style={{ position: "relative" }}>{/* 
                {loading && <Spinner />} */}
                <div>
                    <BreadCrum etiquetas={etiquetas} />
                </div>
                <div className="d-flex justify-content-center mt-5">
                <Col sm={10}>
                    <Input
                        id="exampleFile"
                        name="file"
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                    />
                    <FormText>
                        Seleccione el archivo que desea importar
                    </FormText>
                </Col>
                </div>
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <Button  className=" mb-3" onClick={handleImport} color="primary" otype="submit">
                                Importar
                            </Button>

                            <Button  className="ms-3 mb-3" onClick={handleCreateSubmit} color="primary" otype="submit">
                                Guardar
                            </Button>
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTokenCheck(AppImportTutela);
